function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M48,92C23.7,92,4,72.3,4,48S23.7,4,48,4s44,19.7,44,44S72.3,92,48,92z M48,12c-19.9,0-36,16.1-36,36    s16.1,36,36,36s36-16.1,36-36S67.9,12,48,12z"
})), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M48,71c-2.2,0-4-1.8-4-4V44c0-2.2,1.8-4,4-4s4,1.8,4,4v23C52,69.2,50.2,71,48,71z"
})), React.createElement("g", null, React.createElement("circle", {
  cx: 48,
  cy: 31,
  r: 4
}), React.createElement("path", {
  d: "M48,36c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S50.8,36,48,36z M48,28c-1.7,0-3,1.3-3,3s1.3,3,3,3     s3-1.3,3-3S49.7,28,48,28z"
}))));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.0053801b.svg";
export { ForwardRef as ReactComponent };